export { skillsSk } from './sk';
export { skillsEn } from './en';
export { skillsCz } from './cz';

// Helper function to get skills by language
import { skillsSk } from './sk';
import { skillsEn } from './en';
import { skillsCz } from './cz';

export function getSkills(lang: 'sk' | 'en' | 'cz') {
  switch (lang) {
    case 'sk':
      return skillsSk;
    case 'en':
      return skillsEn;
    case 'cz':
      return skillsCz;
    default:
      return skillsSk; // fallback to Slovak
  }
}
